import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaRocket, FaWhatsapp, FaRobot, FaCog, FaHeadset } from 'react-icons/fa';
import useBillingStore from '../../services/useBillingStore';
import './ActivationModal.css';

const ActivationModal = ({ isOpen, onClose, canClose = false }) => {
  const { subscription, fetchSubscription } = useBillingStore();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadSubscription = async () => {
      setIsLoading(true);
      await fetchSubscription();
      setIsLoading(false);
    };

    if (isOpen) {
      loadSubscription();
    }
  }, [isOpen, fetchSubscription]);

  // Verificar se precisa de pagamento
  const needsPayment = subscription?.needs_payment ||
    ['pending_payment', 'trialing', 'past_due'].includes(subscription?.status);

  // Se nao precisa de pagamento, nao mostra o modal
  if (!needsPayment && !isLoading) {
    return null;
  }

  const handleActivatePlan = () => {
    if (subscription?.checkout_url) {
      // Abrir checkout em nova aba
      window.open(subscription.checkout_url, '_blank');
    } else {
      // Fallback: redirecionar para pagina de planos
      window.location.href = '/configuracoes?tab=billing';
    }
  };

  const handleContactSupport = () => {
    // Abrir WhatsApp do suporte
    const supportPhone = '5548991771777'; // TODO: Pegar do config
    const message = encodeURIComponent(
      'Ola! Acabei de me cadastrar no FastTeam e gostaria de saber mais sobre os planos e fazer o onboarding.'
    );
    window.open(`https://wa.me/${supportPhone}?text=${message}`, '_blank');
  };

  // Não renderiza nada se o modal está fechado
  // Importante: Esta verificação DEVE estar fora do AnimatePresence
  // para evitar conflitos de remoção DOM com React 19
  if (!isOpen) {
    return null;
  }

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key="activation-modal-overlay"
        className="activation-modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={canClose ? onClose : undefined}
      >
        <motion.div
          key="activation-modal-content"
          className="activation-modal"
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.9, y: 20 }}
          transition={{ type: 'spring', duration: 0.5 }}
          onClick={(e) => e.stopPropagation()}
        >
            {/* Header com icone */}
            <div className="activation-modal-header">
              <div className="activation-icon-wrapper">
                <FaRocket className="activation-icon" />
              </div>
              <h2>Seu workspace esta pronto!</h2>
              <p className="activation-subtitle">
                Para liberar todas as funcionalidades, ative um plano agora.
              </p>
            </div>

            {/* Features que serao liberadas */}
            <div className="activation-features">
              <div className="activation-feature">
                <FaWhatsapp className="feature-icon whatsapp" />
                <span>WhatsApp Business</span>
              </div>
              <div className="activation-feature">
                <FaRobot className="feature-icon ai" />
                <span>Agente de IA</span>
              </div>
              <div className="activation-feature">
                <FaCog className="feature-icon automation" />
                <span>Automacoes</span>
              </div>
            </div>

            {/* CTA Principal */}
            <button
              className="activation-btn-primary"
              onClick={handleActivatePlan}
              disabled={isLoading}
            >
              {isLoading ? 'Carregando...' : 'Ativar Plano Agora'}
            </button>

            {/* CTA Secundario */}
            <button
              className="activation-btn-secondary"
              onClick={handleContactSupport}
            >
              <FaHeadset className="btn-icon" />
              Falar com Especialista
            </button>

            {/* Info sobre trial */}
            {subscription?.status === 'trialing' && (
              <p className="activation-trial-info">
                Voce esta em periodo de teste. Ative seu plano para continuar usando apos o periodo.
              </p>
            )}

            {/* Fechar modal (se permitido) */}
            {canClose && (
              <button className="activation-btn-close" onClick={onClose}>
                Continuar explorando
              </button>
            )}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ActivationModal;
